import type { JSX } from 'preact';
import { ChevronDownIcon } from 'lucide-react';
import { FieldFrame } from '@/components/field.js';

type NativeSelectProps = Omit<JSX.IntrinsicElements['select'], 'class' | 'className'>;

/** A bare string is its own label — the `US_STATES` case. */
type SelectOption = string | { value: string; label: string };

type SelectProps = NativeSelectProps & {
  label: string;
  labelAux?: string;
  error?: string;
  hint?: string;
  /** Shown as a disabled first option; omit for a select with no empty state. */
  placeholder?: string;
  options: readonly SelectOption[];
  id: string;
};

/** The select sibling of `Field`: same frame, `appearance: none`, overlaid chevron. */
export function Select({
  label,
  labelAux,
  error,
  hint,
  placeholder,
  options,
  id,
  ...selectProps
}: SelectProps) {
  return (
    <FieldFrame label={label} labelAux={labelAux} error={error} hint={hint} htmlFor={id}>
      <div className="sm-select-wrap">
        <select
          id={id}
          className="sm-control sm-input sm-select"
          aria-invalid={error !== undefined || undefined}
          {...selectProps}
        >
          {placeholder !== undefined ? (
            <option value="" disabled>
              {placeholder}
            </option>
          ) : null}
          {options.map((o) => {
            const { value, label } = typeof o === 'string' ? { value: o, label: o } : o;
            return (
              <option key={value} value={value}>
                {label}
              </option>
            );
          })}
        </select>
        <ChevronDownIcon className="sm-select-chevron" size={16} aria-hidden="true" />
      </div>
    </FieldFrame>
  );
}
